export default __webpack_public_path__ + "static/media/speech_bubble_right.525950a7.svg";